import mutations from './mutations'
import actions from './actions'

const state = {
  actid: "SQ0227", //默认值
  rewardImages: [],
  headImg: null,
  bgColor: "#ffffff",

  rules: [],
  ruleBgColor: null,
  ruleColor: null,

  bottonBgColor: null,
  bottonWords: '',
  bottonWordsColor: null,

  circle: null,
  underColor: null,
  underWords: '',

  shareConfig: null
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/receiveFree/store/index.js